import { render } from "./AllAcknowledgements.vue?vue&type=template&id=21db5b12&scoped=true"
import script from "./AllAcknowledgements.vue?vue&type=script&lang=js"
export * from "./AllAcknowledgements.vue?vue&type=script&lang=js"

import "./AllAcknowledgements.vue?vue&type=style&index=0&id=21db5b12&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21db5b12"]])

export default __exports__